import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faCcAmex,
  faCcMastercard,
  faCcVisa,
  faCcDinersClub,
  faCcDiscover,
  faCcJcb,
  faFacebook,
  faInstagram,
  faTwitter,
  faLinkedin,
  faYoutube,
} from '@fortawesome/free-brands-svg-icons'; // fab
import { faExclamationCircle, faSms } from '@fortawesome/free-solid-svg-icons'; // fas
import {
  faHandHoldingUsd,
  faMapMarkerAlt,
  faAngleDown,
  faAngleUp,
  faTimes,
  faInfoCircle,
  faCheck,
  faBolt,
  faFire,
  faHome,
  faUniversity,
  faCopy,
  faFileAlt,
} from '@fortawesome/free-solid-svg-icons'; // fal
import {
  faCircle,
  faCheckCircle,
  faBolt as faBoltRegular,
  faFire as faFireRegular,
  faCheck as faCheckRegular,
  faExclamationTriangle,
  faSquare,
  faCheckSquare,
  faEnvelope,
  faExternalLinkSquareAlt,
  faSearch,
  faLink,
} from '@fortawesome/free-solid-svg-icons'; // far
import {
  faCreditCard,
  faChevronRight,
  faCheckSquare as faCheckSquareSolid,
  faCheck as faCheckSolid,
  faAngleDown as faAngleDownSolid,
  faFire as faFireSolid,
  faBolt as faBoltSolid,
  faSpinner,
  faUserCircle,
  faCaretUp,
  faSun,
  faCaretDown,
  faComment,
} from '@fortawesome/free-solid-svg-icons'; // fas

// Common Icons
library.add(
  faCcAmex,
  faCcMastercard,
  faCcVisa,
  faCcDinersClub,
  faCcDiscover,
  faCcJcb,
  faTwitter,
  faHandHoldingUsd,
  faFacebook,
  faInstagram,
  faLinkedin,
  faCreditCard,
  faBolt,
  faBoltRegular,
  faBoltSolid,
  faFire,
  faFireRegular,
  faFireSolid,
  faHome,
  faMapMarkerAlt,
  faAngleDown,
  faAngleUp,
  faTimes,
  faCircle,
  faChevronRight,
  faInfoCircle,
  faCheck,
  faCheckRegular,
  faCheckSolid,
  faExclamationCircle,
  faExclamationTriangle,
  faYoutube,
  faUniversity,
  faSquare,
  faCheckSquare,
  faEnvelope,
  faExternalLinkSquareAlt,
  faSpinner,
  faUserCircle,
  faCheckSquareSolid,
  faCaretUp,
  faCaretDown,
  faSearch,
  faSun,
  faSun,
  faLink,
  faCopy,
  faComment,
  faSms,
  faCheckCircle,
  faFileAlt
);

// Theme Specific Icons
library.add(faAngleDownSolid);
